import React, { Fragment, useState, useEffect } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useTranslation } from 'react-i18next';
import travelimg from '../tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import { event } from "jquery";
const { config } = require('../api/api');


function NewpolicyGeneralInformation() {
  const base_url = config.baseURL;

  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';


  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    insurancetype: '',
  });
  const [loading, setLoading] = useState(false);
  const [selectedDateofBirth, setSelectedDateofBirth] = useState(null);
  const [fromdate, setFromdate] = useState(null);
  const [todate, settodatevalue] = useState(null);
  const [mobilenumber, setmobilenumber] = useState(null);
  const [email, setemailValue] = useState(null);
  const [cliamhistory, setcliamhistoryvalue] = useState(null);
  const [years, setyearsvalue] = useState(null);
  const [vendorKey, setVendorkey] = useState('');


  // const [selectedqOption, setSelectedqOption] = useState(null);
  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day); // month is 0-indexed
  };

  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = parseDate(dob);

    // Check if birthDate is valid
    if (isNaN(birthDate.getTime())) {
      throw new Error('Invalid date');
    }

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birth date hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };




  useEffect(() => {

    const postvData = { organization_name: "Superjet" };
    debugger

    if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {


      fetch( base_url + '/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postvData),
      })
        .then(response => response.json())
        .then(data => {
          setVendorkey(data.result[0].vendor_key);
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });


    }
  }, [vendorKey]); // Dependency array


  const handleSubmit = async (event) => {

    debugger

    // var data = {
    //   "basicinfo_gender_id": selectedgenderOptionid,
    //   "basicinfo_gender_detail": selectedgenderOption,
    //   "basicinfo_marital_status_id": selectedmaritalOptionid,
    //   "basicinfo_marital_status_detail": selectedmaritalOption,
    //   "dob": selectedDateofBirth
    // }

    // debugger

    // sessionStorage.setItem("personalaccidentbasicinfo", JSON.stringify(data))

    event.preventDefault();
    setLoading(true);

    event.preventDefault();
    window.location.href = '/newpolicy-otp';

  };

//   useEffect(() => {
//     debugger
//     const basicvalue = sessionStorage.getItem('personalaccidentbasicinfo');
//     if (basicvalue != undefined) {
//       const value = JSON.parse(basicvalue);
//       setSelectedGender(value.basicinfo_gender_detail);
//       setSelectedmarital(value.basicinfo_marital_status_detail);
//       setSelectedDateofBirth(value.dob);
//       setSelectedgenderOption(value.basicinfo_gender_detail);
//       setSelectedgenderOptionid(value.basicinfo_gender_id);
//       setSelectedmaritalOptionid(value.basicinfo_marital_status_id);
//       setSelectedmaritalOption(value.basicinfo_marital_status_detail);

//     }

//   }, []);

  const [dhofarData, setDhofarData] = useState(false);
  const [age, setAge] = useState(null);
  useEffect(() => {


    const storedDhofarString = Cookies.get('personalData'); //sessionStorage.getItem('userData')
    if (storedDhofarString !== undefined) {
      const storedDhofar = JSON.parse(storedDhofarString);
      setDhofarData(storedDhofar);
    }
    else {
      // alert("token expired");
      // window.location.href='/';
    }

  }, []);


  const [buttonDisabled, setButtonDisabled] = useState(false);
  const postData = { token: dhofarData };
  // const today = new Date().toISOString().split('T')[0];
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate() + 1).toISOString().split('T')[0];
  const minDate = new Date(today.getFullYear() - 60, today.getMonth(), today.getDate()).toISOString().split('T')[0];

  const [dobValue, setdobValue] = useState('');
  const handledobChange = (event) => {
    const selectedDob = event.target.value;
    setdobValue(event.target.value);

    const dobDate = new Date(selectedDob);
    const today = new Date();
    let calculatedAge = today.getFullYear() - dobDate.getFullYear();
    const monthDiff = today.getMonth() - dobDate.getMonth();

    // Adjust age if the current date is before the user's birthday in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
      calculatedAge--;
    }

    setAge(calculatedAge);
  };

  
  const handleFromdateChange = (event) => {
    setFromdate(event.target.value)
  };

  const handleTodateChange =(event) => {
    settodatevalue(event.target.value)
  };

  const handlenumberChange = (event) => {
    setmobilenumber(event.target.value)
  };

  const handleemailChange = (event) => {
    setemailValue(event.target.value)
  };

  const handlecliamhistoryChange = (event) => {
    setcliamhistoryvalue(event.target.value)
  };

  const handleyearsChange = (event) => {
    setyearsvalue(event.target.value)
  };



 
  //getgender

//   const [goptions, setGender] = useState([]);
//   const [moptions, setMarital] = useState([]);

//   useEffect(() => {
//     if (goptions && goptions.length === 0 && vendorKey !== '') {

      

//       debugger
//       fetch(base_url + '/getGender', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${vendorKey}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(postData),
//       })
//         .then(response => response.json())
//         .then(data => {
//           setGender(data.result.data.response_data);
//           married()

//         })
//         .catch(error => {
//           console.error('Error posting data:', error);
//         });

//     }    
//   },[vendorKey]
//   );

//   const married = () => {
//     if (moptions && moptions.length === 0 && vendorKey !== '') {
//       setLoading(true);

//       fetch(base_url + '/getMaritalStatus', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${vendorKey}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(postData),
//       })
//         .then(response => response.json())
//         .then(data => {

//           setMarital(data.result.data.response_data);
//           setLoading(false);


//         })
//         .catch(error => {
//           console.error('Error posting data:', error);
//         });

//     }
//   };






  // const isButtonDisabled =  






  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'New Policy' : 'سياسة جديدة\n'}</h3>
          </div>
        </div>


      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5">



              <h4 className="px-0 py-2">{(lnstr === 'en') ? 'General Information' : 'معلومات عامة\n'}</h4>

              <form onSubmit={handleSubmit}>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{(lnstr === 'en') ? 'From Date':'من التاريخ'}</span>
                  </div>
                  <input type="date" name="fromdate" className="form-control" onChange={handleFromdateChange} required/>
                </div>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{(lnstr === 'en') ? 'To Date':'حتى الآن'}</span>
                  </div>
                  <input type="date" name="todate" className="form-control" onChange={handleTodateChange} required/>
                </div>


                <div className="input-group mb-2 mt-2">
                    <div className="input-group-prepend prepends">
                        {/* <span className="input-group-text">{(lnstr === 'en') ? 'Mobile Number':'رقم الهاتف المحمول'}</span> */}
                    </div>
                    <input type="text" name="mobilenumber" placeholder={(lnstr === 'en') ? 'Mobile Number':'رقم الهاتف المحمول'}
                    maxLength={6} className="form-control" onChange={handlenumberChange} required/>
                </div>

                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    {/* <span className="input-group-text">{(lnstr === 'en') ? 'Email ID':'معرف البريد الإلكتروني'}</span> */}
                  </div>
                  <input type="mail" name="email" placeholder={(lnstr === 'en') ? 'Email ID':'معرف البريد الإلكتروني'} className="form-control" onChange={handleemailChange} required/>
                </div>


                <div className="input-group mb-2 mt-2">
                    <div className="input-group-prepend prepends">
                        {/* <span className="input-group-text">{(lnstr === 'en') ? 'Cliam History':'تاريخ المطالبة'}</span> */}
                    </div>
                    <select  name="cliamhistory" className="form-control" onChange={handlecliamhistoryChange} required>
                    <option value='' disabled selected>{(lnstr === 'en') ? 'Cliam History':'تاريخ المطالبة'}</option>
                  </select>
                </div>


                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    {/* <span className="input-group-text">{(lnstr === 'en') ? 'No. Of Year':'رقم السنة'}</span> */}
                  </div>
                  <select  name="year"  className="form-control" onChange={handleyearsChange} required>
                    <option value='' disabled selected>{(lnstr === 'en') ? 'No. Of Year':'رقم السنة'}</option>
                  </select>
                </div>



                {/* <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend prepends">
                    <span className="input-group-text">{(lnstr === 'en') ? 'Marital Status' : 'الحالة الأجتماعية'}</span>
                  </div>
                  <select value={selectedmarital} name="maritalstatus" className="form-control" onChange={handlemaritalChange}
                    required>
                    <option>{(lnstr === 'en') ? '-- Select --' : '--اختار--'}</option>
                  </select>
                </div> */}


                <button type="submit"  className="btn btn-primary rounded-pill text-white my-1 py-1 px-4">{(lnstr === 'en') ? '  Continue':'إنشاء كلمة المرور لمرة واحدة'}</button>


              </form>


            </Col>

            <Col md={3}></Col>

          </div>

        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );


}

export default NewpolicyGeneralInformation;
